import { styled } from '@styles/config'

export const Card = styled('div', {
  backgroundColor: '$white',
  borderRadius: '$radius',
  boxShadow: '$card',
  display: 'flex',
  flexDirection: 'column',
})
